import React, { useState } from 'react';
import axios from 'axios';
import { X, Check } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DownloadModal = ({ open, onClose, source = 'download_modal' }) => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/signups`, { email, source });
      setSent(true);
    } catch (err) {
      setError('Something went wrong. Please check your email and try again.');
    } finally {
      setLoading(false);
    }
  };

  const close = () => { setSent(false); setEmail(''); setError(''); setLoading(false); onClose(); };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-[#0b1510]/60 backdrop-blur-sm" onClick={close} />
      <div className="relative w-full max-w-md bg-white rounded-3xl p-8 shadow-2xl rise-in">
        <button onClick={close} className="absolute top-5 right-5 text-[#0f1712]/40 hover:text-[#0f1712] transition-colors">
          <X size={22} />
        </button>
        {!sent ? (
          <>
            <span className="brand text-2xl text-[#0f1712]">flix<span className="text-[#0e9f6e]">.</span></span>
            <h3 className="font-display text-3xl font-700 text-[#0f1712] mt-5 leading-tight">Start selling in minutes</h3>
            <p className="text-[#0f1712]/55 text-sm mt-3 mb-6">
              Drop your email and we’ll send a download link. Your phone becomes a checkout in minutes.
            </p>
            <form onSubmit={submit} className="space-y-3">
              <input
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="you@email.com"
                className="w-full rounded-xl border border-[#0f1712]/15 bg-white px-5 py-3.5 text-sm text-[#0f1712] outline-none focus:border-[#0e9f6e] focus:ring-2 focus:ring-[#0e9f6e]/30 transition"
              />
              {error && <p className="text-sm text-red-500">{error}</p>}
              <button type="submit" disabled={loading} className="w-full bg-[#0e9f6e] text-white rounded-xl px-5 py-3.5 text-sm font-semibold hover:bg-[#0c8a60] transition-colors disabled:opacity-60">
                {loading ? 'Sending…' : 'Send me the link'}
              </button>
            </form>
          </>
        ) : (
          <div className="text-center py-6">
            <div className="mx-auto w-14 h-14 rounded-full bg-[#e8f5ee] flex items-center justify-center mb-4">
              <Check size={28} className="text-[#0e9f6e]" />
            </div>
            <h3 className="font-display text-2xl font-700 text-[#0f1712]">Check your inbox</h3>
            <p className="text-[#0f1712]/55 text-sm mt-2">We sent a download link to <span className="font-semibold text-[#0f1712]">{email}</span>.</p>
            <button onClick={close} className="mt-6 bg-[#0e9f6e] text-white rounded-xl px-6 py-3 text-sm font-semibold">Done</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DownloadModal;
